import { generateUid } from 'utils/functions';
import { typesGridBanner } from 'utils/imgList';
import { HomeModuleItemListProps } from 'types/ItemTypeBannersHome';

export const listOptions: HomeModuleItemListProps[] = [
	{
		id: generateUid(),
		name: 'Banner duplo',
		type: 0,
		description: 'Banner duplo',
		image: typesGridBanner.bannerDuplo
	},
	{
		id: generateUid(),
		name: 'Banner triplo',
		type: 1,
		description: 'Banner triplo',
		image: typesGridBanner.bannerTriplo
	},
	{
		id: generateUid(),
		name: 'Banner triplo à esquerda',
		type: 2,
		description: 'Banner triplo à esquerda',
		image: typesGridBanner.BannerTriploaEsquerda
	},
	{
		id: generateUid(),
		name: 'Banner triplo à direita',
		type: 3,
		description: 'Banner triplo à direita',
		image: typesGridBanner.BannerTriploaDireita
	},
	{
		id: generateUid(),
		name: 'Banner duplo vertical',
		type: 4,
		description: 'Banner duplo vertical',
		image: typesGridBanner.banneDuploVertical
	},
	{
		id: generateUid(),
		name: 'Banner mosaico',
		type: 5,
		description: 'Banner mosaico',
		image: typesGridBanner.bannerMosaico
	},
	{
		id: generateUid(),
		name: 'Banner mosaico triplo',
		type: 6,
		description: 'Banner mosaico triplo',
		image: typesGridBanner.bannerMosaicoTriplo
	}
];
